/**
 * Model text is chat output, not authored markdown: a `<TAG>` run is
 * text (react-markdown would parse it as HTML and silently DROP it),
 * and a lone newline is a real break (markdown would collapse it into
 * the previous line). Escape the one and harden the other before
 * rendering. Known cost: inside a code span the escape shows as a
 * literal backslash, which is visible rather than lost.
 */
export function chatMarkdown(text: string): string {
  return text.replace(/</g, '\\<').replace(/([^\n])\n(?!\n)/g, '$1  \n')
}
